import {
    BarChartIcon,
    BoxChartIcon,
    ClassDiagramIcon,
    FlowchartIcon,
    LineChartIcon,
    MindMapIcon,
    NetworkDiagramIcon,
    OrgChartIcon,
    PieChartIcon,
    ScatterChartIcon,
    SequenceDiagramIcon,
    StateDiagramIcon,
    SurfaceChartIcon,
    UseCaseIcon,
} from './chartIcons';

// 图表类型（取值与后端 ChartTypeProcessor 一致）
export const ChartType = {
    LINE: 'line',
    SURFACE: 'surface',
    PIE: 'pie',
    BAR: 'bar',
    SCATTER: 'scatter',
    BOX: 'box',
    FLOWCHART: 'flowchart',
    MIND_MAP: 'mindMap',
    ORG_CHART: 'orgChart',
    USE_CASE: 'useCase',
    CLASS_DIAGRAM: 'classDiagram',
    STATE_DIAGRAM: 'stateDiagram',
    SEQUENCE_DIAGRAM: 'sequenceDiagram',
    NETWORK_DIAGRAM: 'networkDiagram',
    OTHER: 'other',
};

export const CHART_GROUPS = [
    {
        title: '数据分析图表',
        charts: [
            { type: ChartType.LINE, label: '折线图', icon: LineChartIcon },
            { type: ChartType.SURFACE, label: '曲面图', icon: SurfaceChartIcon },
            { type: ChartType.PIE, label: '饼图', icon: PieChartIcon },
            { type: ChartType.BAR, label: '柱状图', icon: BarChartIcon },
            { type: ChartType.SCATTER, label: '散点图', icon: ScatterChartIcon },
            { type: ChartType.BOX, label: '箱型图', icon: BoxChartIcon },
        ],
    },
    {
        title: '结构与流程图',
        charts: [
            { type: ChartType.FLOWCHART, label: '流程图', icon: FlowchartIcon },
            { type: ChartType.MIND_MAP, label: '思维导图', icon: MindMapIcon },
            { type: ChartType.ORG_CHART, label: '组织结构图', icon: OrgChartIcon },
            { type: ChartType.USE_CASE, label: '用例图', icon: UseCaseIcon },
        ],
    },
    {
        title: '技术与专业图',
        charts: [
            { type: ChartType.CLASS_DIAGRAM, label: '类图', icon: ClassDiagramIcon },
            { type: ChartType.STATE_DIAGRAM, label: '状态图', icon: StateDiagramIcon },
            { type: ChartType.SEQUENCE_DIAGRAM, label: '时序图', icon: SequenceDiagramIcon },
            { type: ChartType.NETWORK_DIAGRAM, label: '网络图', icon: NetworkDiagramIcon },
        ],
    },
];

export const CHART_MAP = {};
CHART_GROUPS.forEach((group) =>
    group.charts.forEach((chart) => {
        CHART_MAP[chart.type] = chart;
    }),
);

const SvgIcon = ({ children }) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
        {children}
    </svg>
);

export const AcademicImageIcon = () => (
    <SvgIcon>
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="M21 15L16 10L6 21"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

export const AcademicTableIcon = () => (
    <SvgIcon>
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 9H21" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 15H21" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 3V21" stroke="currentColor" strokeWidth="1.8" />
    </SvgIcon>
);

export const AcademicFormulaIcon = () => (
    <SvgIcon>
        <path
            d="M7 4C7 4 5 4 5 7V17C5 20 7 20 7 20"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
        />
        <path d="M5 12H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path
            d="M13 8L19 8M13 12H17M13 16L19 16"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
        />
        <circle cx="11" cy="6" r="1" fill="currentColor" />
        <circle cx="11" cy="18" r="1" fill="currentColor" />
    </SvgIcon>
);

export const AcademicCodeIcon = () => (
    <SvgIcon>
        <path
            d="M8 6L3 12L8 18"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 6L21 12L16 18"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M14 4L10 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </SvgIcon>
);

export const AcademicWebSearchIcon = () => (
    <SvgIcon>
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
        <path d="M11 4C11 4 8 7 8 11C8 15 11 18 11 18" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 4C11 4 14 7 14 11C14 15 11 18 11 18" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 11H18" stroke="currentColor" strokeWidth="1.5" />
        <path d="M16 16L21 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </SvgIcon>
);

// 插入类型配置（各类型用固定的分类色，便于区分）；short 是手机上切换按钮里的短标签
export const EXTRA_TYPES = {
    image: { key: 'image', label: '图片', short: '图', icon: <AcademicImageIcon />, color: '#389e0d' },
    table: { key: 'table', label: '表格', short: '表', icon: <AcademicTableIcon />, color: '#1677ff' },
    formula: {
        key: 'formula',
        label: '公式',
        short: '公式',
        icon: <AcademicFormulaIcon />,
        color: '#722ed1',
    },
    code: { key: 'code', label: '代码', short: '代码', icon: <AcademicCodeIcon />, color: '#08979c' },
    webSearch: {
        key: 'webSearch',
        label: '联网搜索',
        short: '数据',
        icon: <AcademicWebSearchIcon />,
        color: '#c41d7f',
    },
};
